import { Box, Stack, Typography } from '@mui/material'

import { usePageTracking } from '@services/hooks/useGoogleAnalytics'
import { PAGE_TRACKING_DATA, GA_CONFIG } from '@features/config/analytics'

import plane from '../media/plane.svg'
import Styles from './style'

export const Home = () => {
    usePageTracking({
        ...GA_CONFIG.default_data,
        ...PAGE_TRACKING_DATA.home
    })

    return (
        <Box style={Styles.wrapper}>
            <Box style={Styles.whiteSectionClip}>
                <Box style={Styles.content}>
                    <Box sx={{width: '80%'}}>
                        <Typography variant={'display2'}>Landing Zone Cockpit</Typography>
                        <Typography sx={{mt: 1, fontSize: '30px', fontWeight: 400, color: '#3360F6'}}>
                            As a Landing Zone User, I need to access all the logs generated by my workloads.
                        </Typography>
                    </Box>
                    <Box sx={{width: '50%', mt: '70px'}}>
                        <Typography variant={'h3'}>Landing Zone Cockpit, is a service</Typography>
                        <Typography variant={'body1'} sx={{mt: 1}}>
                            to ease your autonomy on your Landing Zone journey. It will provide tools to help you master your landing zone and get full visibility of what’s going on.
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Stack direction={'row'} justifyContent={'end'} sx={{width: '100%'}}>
                <Box sx={{zIndex: 1}}>
                    <img src={plane} alt={'home'}/>
                </Box>
            </Stack>
        </Box>
    )
}

export default Home